import { useExperimentTreatmentWithoutReporting } from '../experiments';
import { useFeatureAccessSettings } from '../featureAccessSettings';

export const useIsQnAOrgEntryPointVisible = (): boolean => {
  const isVivaAnswersEnabled = useExperimentTreatmentWithoutReporting('AnswersInVivaGA') === true;
  const viewerCanAccessNetworkLevelInsights = useFeatureAccessSettings()?.viewerCanAccessNetworkLevelInsights;
  const viewerCanAccessNetworkQuestions = useFeatureAccessSettings()?.viewerCanAccessNetworkQuestions;

  return (
    isVivaAnswersEnabled && viewerCanAccessNetworkLevelInsights === true && viewerCanAccessNetworkQuestions === true
  );
};
